<template>
	<b-modal id="language-modal" title="Language" centered hide-footer >
		<div v-if = "adding || editing">
			<div class = "mb-3">
				<button class = "btn btn-profile" @click = "cancel">Cancel</button>
				<button class = "btn btn-profile" @click = "submit">Submit</button>
			</div>
			<div style = "display: inline-block;" class="mr7" v-for = "m in LanguageChoices" @click = "form['language'] = m">
				<button class = "btn btn-sm btn-gradient-success selected" v-if = "form['language'] === m">{{m}}</button>
				<button class = "btn btn-sm btn-gradient-danger" v-else>{{m}}</button>
			</div>
			<p class = "font-red" v-if = "errorMsg['language']">{{errorMsg['Language']}}</p>
		</div>
		<div v-else>
			<div>
				<button class="btn-profile" @click = "editStart(oriItem)">Edit</button>
			</div>
			<div class="mt1">
				Currently Selected Language: {{oriItem.language || 'en-uk'}}
			</div>
		</div>
	</b-modal>
</template>
<script>
import myInput from "./crudDSInputManager.js";
//==================================================//
//													//
//					DATA TEMPLATE					//
//													//
//==================================================//
var dbPath;
var docID;
var itemTemplate = [
{
	"Name": "language",
	"Type": "choice",
	"Checking": "text",
	"CheckFields": {
		"ValueType": "Preset",
		"SelectType": "Buttons",
		"Values": "en-uk,bm,cn",
		"errorMsg": "Please pick a choice."
	},
	"DefaultValue": "",
	"Placeholder": "Text",
	"Multiview": true,
	"Unique": false,
	"Compulsory": true,
	"show": true,
	"edit": true
}
];
export default {
	//==============================================//
	//												//
	//					DATA						//
	//												//
	//==============================================//
	data(){
		return{
			// FORM
			form: {},
			errorMsg: {},

			// NAV VARIABLES
			adding: false,
			editing: false,
			viewing: false,
			sorting: false,

			// FILTER
			filterText: "",

			// DATA STORAGE AND MANIPULATION
			items: [],
			oriItem: {
				language: this.$store.getters.getLanguage()
			},
			indices: [],
			editIndex: "",

			// FILTER
			filterText: "",

			// CHOICES AND RANGES
			LanguageChoices: ["en-uk","bm","cn"],
		}
	},

	firestore(){
	},
	mounted(){
		global.language = {
			show:(string) =>{
				this.editStart(this.oriItem);
				this.$bvModal.show('language-modal');
			}
		}
	},
	// WATCHER
	watch:{
	},
	//==============================================//
	//												//
	//					METHODS						//
	//												//
	//==============================================//
	methods:{
		//-------------------------------- CREATE -------------------------------//
		duplicate(item){
			this.form = myInput.editMain(item, itemTemplate);
			this.errorMsg = myCopier.copyAs(item,"");
			this.adding = true;
		},
		addStart(){
			var response = myInput.init(itemTemplate, this);
			this.errorMsg = myCopier.copyAs(response, "");
			this.form = response;
			this.adding = true;
		},
		//------------------------------- UPDATE --------------------------------//
		editStart(item, ID, docIndex){
			var form = myCopier.copy(item);
			delete form[".key"];
			var response = myInput.editMain(form, itemTemplate);
			this.errorMsg = myCopier.copyAs(form, "");
			this.form = response;
			this.editIndex = myFB.auth.currentUser.uid;
			this.editing = true;
		},
		//-------------------------------- SUBMIT -------------------------------//
		submit(){
			var response;
			var allowAdd = true;
			var form = myCopier.copy(this.form);
			response = myInput.checkMain(form, itemTemplate);
			this.errorMsg = response.errorMsg;
			if (response.error){
				allowAdd = false;
			}
			if (allowAdd){
				this.$store.commit("updateLanguage", {
					bID: this.$route.params.businessID,
					language: response.output.language
				})
				this.$router.go();
			}
		},
		viewStart(item){
			var form = myCopier.copy(item);
			delete form[".key"];
			var response = myInput.editMain(form, itemTemplate);
			this.form = response;
			this.viewing = true;
		},
		//------------------------------- DELETE --------------------------------//
		deleteItem(item, ID){
			if (confirm("Confirm deleting?")){
				if (item.PhotoRESERVED != "" && item.PhotoRESERVED != undefined){
					myFB.storage.ref(dbPath + "/" + ID).delete();
				}
				var update = {};
				update["Test." + ID] = myFB.fieldVal.delete();
				update["TestIndices"] = myFB.fieldVal.arrayRemove(ID);
				myFB.updateDoc(dbPath, update, docID, this, "Deleting..." , "Deleted!");
			};
		},
		//-------------------------------- SORT ---------------------------------//
		sortStart(){
			this.sorting = true;
			setTimeout(()=>{
				var sortable = $("#TestList").sortable({
					delay: 50,
					disable: false
				});
				sortable.sortable("enable");
			}, 300);
		},
		sortSubmit(){
			var arr = $( "#TestList").sortable("toArray");
			var sortable = $("#TestList").sortable("cancel");
			sortable.sortable("disable");
			var update = {};
			update["TestIndices"] = arr;
			myFB.updateDoc(dbPath, update, docID, this);
			this.sorting = false;
		},
		sortCancel(){
			var sortable = $("#TestList").sortable("cancel");
			sortable.sortable("disable");
			this.sorting = false;
		},
		//------------------------------- OTHERS --------------------------------//
		filterItem(item, text){
			this.viewing = false;
			this.adding = false;
			this.editing = false;
			this.sorting = false;
		},
		cancel(){
			this.viewing = false;
			this.adding = false;
			this.editing = false;
			this.sorting = false;
		},
		addChoice(element, choice){
			if (element.includes(choice)){
				element.splice(element.indexOf(choice),1);
			}
			else{
				element.push(choice);
			}
		},
		updateUI(){
			var form = myCopier.copy(this.form);
			var errorMsg = myCopier.copy(this.errorMsg);
			this.form = form;
			this.errorMsg = errorMsg;
		},
		addElement(elementNames, elementIndices){
			var temp = myCopier.copy(itemTemplate);
			var argNum = 0;
			var form = this.form;
			var errorMsg = this.errorMsg;

			// Obtains template from data hierarchy.
			elementNames.forEach((name, nameIndex)=>{
				temp = temp.filter(r=>{
					return r.Name === name;
				})[0];
				form = form[name];
				errorMsg = errorMsg[name];
				if(temp.Type === "Array" && nameIndex < elementNames.length - 1){
					form = form[elementIndices[argNum]];
					errorMsg = errorMsg[elementIndices[argNum]];
					argNum++;
				}
				temp = temp.children;
			});
			var newElement = myInput.init(temp, this);
			errorMsg.push(myCopier.copyAs(newElement, ""));
			form.push(newElement);
		},
		duplicateElement(element, elementNames, elementIndices){
			var temp = myCopier.copy(itemTemplate);
			var argNum = 0;
			var form = this.form;
			var errorMsg = this.errorMsg;

			// Obtains template from data hierarchy.
			elementNames.forEach((name, nameIndex)=>{
				temp = temp.filter(r=>{
					return r.Name === name;
				})[0];
				form = form[name];
				errorMsg = errorMsg[name];
				if(temp.Type === "Array" && nameIndex < elementNames.length - 1){
					form = form[elementIndices[argNum]];
					errorMsg = errorMsg[elementIndices[argNum]];
					argNum++;
				}
				temp = temp.children;
			});
			errorMsg.push(myCopier.copyAs(element, ""));
			form.push(myCopier.copy(element));
		},
		moveElementUp(elements, elementIndex){
			if (elementIndex > 0){
				var temp = myCopier.copy(elements[elementIndex]);
				elements[elementIndex] = myCopier.copy(elements[elementIndex - 1]);
				elements[elementIndex - 1] = myCopier.copy(temp);
				this.updateUI();
			}
		},
		moveElementDown(elements, elementIndex){
			if (elementIndex < elements.length -1){
				var temp = myCopier.copy(elements[elementIndex]);
				elements[elementIndex] = myCopier.copy(elements[elementIndex + 1]);
				elements[elementIndex + 1] = myCopier.copy(temp);
				this.updateUI();
			}
		},
		copyElement(element){
			copyCode(JSON.stringify(element));
		},
		pasteElement(elementNames, elementIndices){
			var temp = itemTemplate;
			var form = this.form;
			var errorMsg = this.errorMsg;
			var argNum = 0;

			// OBTAINS TEMPLATE FROM DATA HIERARCHY.
			elementNames.forEach((name, nameIndex)=>{
				temp = temp.filter(r=>{
					return r.Name === name;
				})[0];
				form = form[name];
				if(temp.Type === "Array" && nameIndex < elementNames.length-1){
					form = form[elementIndices[argNum]];
					errorMsg = errorMsg[elementIndices[argNum]];
					argNum++;
				}
				temp = temp.children;
			});
			navigator.clipboard.readText().then(text => {
				var element = JSON.parse(text);
				var structureResponse = myInput.checkStructure(element, temp);
				if (structureResponse.disableAdd){
					console.log("WRONG DATA STRUCTURE!");
				}
				else{
					this.duplicateElement(structureResponse.output, elementNames, elementIndices);
				}
			});
		},
		pasteJSON(elementNames, elementIndices){
			var allowPaste = true;
			var argNum = 0;
			var temp = itemTemplate;
			var form = this.form;
			var delay = 0;

			// Obtains template from data hierarchy.
			elementNames.forEach((name, nameIndex)=>{
				temp = temp.filter(r=>{
					return r.Name === name;
				})[0];
				form = form[name];
				if(temp.Type === "Array" && nameIndex < elementNames.length && elementIndices[argNum] != undefined){
					form = form[elementIndices[argNum]];
					argNum++;
				}
				temp = temp.children;
			});
			var notEmpty = myInput.checkEmpty(form, temp);
			if (notEmpty){
				allowPaste = confirm("Confirm pasting? One or more of the children field(s) are filled in.");
				delay = 300;
			}
			if (allowPaste){
				$(document).focus();
				setTimeout(()=>{
					navigator.clipboard.readText().then(text => {
						var newForm = JSON.parse(text);
						var structureResponse = myInput.checkStructure(newForm, temp);
						var errorMsg = structureResponse.errorMsg;
						if (structureResponse.disableAdd){
							console.log("WRONG DATA STRUCTURE!");
						}
						var oriForm = myCopier.copy(this.form);
						var oriErrorMsg = myCopier.copy(this.errorMsg);
						oriForm = myInput.valueChanger(oriForm, elementNames, elementIndices, itemTemplate, structureResponse.output);
						oriErrorMsg = myInput.valueChanger(oriErrorMsg, elementNames, elementIndices, itemTemplate, structureResponse.errorMsg);
						this.form = oriForm;
						this.errorMsg = oriErrorMsg;
					});
				},delay);
			}
		},
		removeElement(elementNames, elementIndices, elementIndex){
			var argNum = 0;
			var temp = itemTemplate;
			var form = this.form;
			var errorMsg = this.errorMsg;

			// Obtains template from data hierarchy.
			elementNames.forEach((name, nameIndex)=>{
				temp = temp.filter(r=>{
					return r.Name === name;
				})[0];
				form = form[name];
				errorMsg = errorMsg[name];
				if(temp.Type === "Array" && nameIndex < elementNames.length - 1){
					form = form[elementIndices[argNum]];
					errorMsg = errorMsg[elementIndices[argNum]];
					argNum++;
				}
				temp = temp.children;
			});
			form.splice(elementIndex, 1);
			errorMsg.splice(elementIndex, 1);
		},
		//------------------------------ FORMAT ------------------------------//
		formatDate(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDate(input, mode);
		},
		formatDateTime(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDateTime(input, mode, {sequence: "hh:mm"});
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},
		//-------------------------------- FILTERS --------------------------------//
		filterItem(item, text){
			var itemText = JSON.stringify(item).toUpperCase();
			var filter = text.toUpperCase();
			return itemText.includes(filter);
		},
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Manager/LanguageChoice.vue